/*global module, require*/

module.exports = {
	calculateLayout: require('./calculate-layout'),
	colorToRGB: require('./color-to-rgb'),
	Connectors: require('./connectors'),
	foregroundStyle: require('./foreground-style'),
	LayoutModel: require('./layout-model'),
	nodeToBox: require('./node-to-box'),
	Theme: require('./theme'),
	ThemeProcessor: require('./theme-processor'),
	ThemeDimensionProvider: require('./theme-dimension-provider'),
	Themes: {
		default: require('./default-theme')
	},
	lineStrokes: require('./line-strokes')
};



//////////////////
// WEBPACK FOOTER
// ./~/mindmup-mapjs-layout/src/mapjs-layout.js
// module id = 3
// module chunks = 0